import React, { useContext, useState } from 'react'
import { AppContext } from '../appState'
import { useMutation, useLazyQuery } from '@apollo/client'

import { MAKE_ADMISSION_REQUEST } from '../mutations'
import { ANONYMOUS_TOKEN } from '../queries'

import { Wizard, Step, Button } from '@welcom/esg-react-components'
import { Pupils } from '../views/Pupils'
import { Guardians } from '../views/Guardians'
import { Siblings } from '../views/Siblings'
import { Fritids } from '../views/Fritids'
import { Review } from '../views/Review'
import { Thanks } from '../views/Thanks'

const mapStoreToGraphqlSchemaInput = store => ({
   pupil: {
      firstName: store.pupil.name,
      lastName: store.pupil.surname,
      personNumber: store.pupil.SSN,
      homeLanguages: store.pupil.language,
      previousSchool: store.pupil.prevSchool,
      preferredStart: store.pupil.startDate,
   },
   guardians: store.guardians.filter(({ email }) => !!email).map(({
      name,
      surname,
      email,
      phoneMobile,
      phoneHome,
      address,
      postalCode,
      city,
   }) => ({
      firstName: name,
      lastName: surname,
      phoneMobile,
      phoneHome,
      email,
      address,
      postalCode,
      city,
   })),
   siblings: store.siblings.map(({
      name,
      surname,
      SSN,
   }) => ({
      firstName: name,
      lastName: surname,
      personNumber: SSN
   })),
   fritids: store.fritids.fritids && {
      dropOff: store.fritids.dropOff,
      pickUp: store.fritids.pickUp,
   }
})

const useMakeAdmissionRequest = ({ onCompleted }) => {
   const [variables, setVariables] = useState(null)
   const [getAnonymousToken] = useLazyQuery(ANONYMOUS_TOKEN, {
      onCompleted(result) {
         console.log({ result })
         localStorage.setItem('token', result.anonymousToken)
         makeAdmissionRequest({ variables })
            .catch(() => { })  //TODO: handle network errors etc.
      }
   })
   const [makeAdmissionRequest] = useMutation(
      MAKE_ADMISSION_REQUEST,
      {
         onCompleted(result) {
            onCompleted(result.makeAdmissionRequest)
         }
      }
   )

   return variables => {
      setVariables(variables)
      getAnonymousToken()
   }
}

export const Steps = () => {
   const {
      disableNext,
      activeStep,
      setActiveStep,
      isSubmitted,
      setIsSubmitted,
      store,
   } = useContext(AppContext)

   const makeAdmissionRequest = useMakeAdmissionRequest({
      onCompleted(result) {
         setIsSubmitted(result)
      }
   })

   /* Show thank you page after submit */
   if (isSubmitted) {
      return <Thanks />
   }

   return (
      <>
         <Wizard
            disableNext={disableNext}
            currentStep={activeStep}
            setCurrentStep={setActiveStep}
            submitButton={() => (
               <Button
                  isPrimary
                  onClick={() => {
                     makeAdmissionRequest({
                        input: mapStoreToGraphqlSchemaInput(store)
                     })
                  }}
                  label={'Submit'}
               />
            )}
         >
            <Step>
               <Pupils />
            </Step>
            <Step>
               <Guardians />
            </Step>
            <Step>
               <Siblings />
            </Step>
            <Step>
               <Fritids />
            </Step>
            <Step>
               <Review />
            </Step>
         </Wizard>
      </>
   )
}
